import { render, staticRenderFns } from "./CustomerVerifyForm.vue?vue&type=template&id=c2a38866"
import script from "./CustomerVerifyForm.vue?vue&type=script&lang=js"
export * from "./CustomerVerifyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports